import { Divider, HStack, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { DOCK_HOURS_OPTIONS, instructionUsageOptions } from '@pelicargo/utils';
import { aircraftTypeOptions } from '@pelicargo/utils';
import { InstructionUsage } from '@prisma/client';
import { useWatch } from 'react-hook-form';

import { AirlineInput } from '../Autocomplete/AirlineInput';
import { AirportInput } from '../Autocomplete/AirportInput';
import { ContactInput } from '../Autocomplete/ContactInput';
import { InstructionFormValues } from '../Drawers/InstructionFormDrawer';
import { SimpleField } from '../SimpleField';
import { SimpleInput } from '../SimpleInput';
import { SimpleNativeDatePicker } from '../SimpleNativeDatePicker';
import { SimpleNumber } from '../SimpleNumber';
import { SimpleSelect } from '../SimpleSelect';
import { SimpleTextarea } from '../SimpleTextarea';
import { SimpleWeekdaySelect } from '../SimpleWeekdaySelect';
import { AddressForm } from './AddressForm';

export const InstructionForm = () => {
  const instructionUsage = useWatch<InstructionFormValues, 'usage'>({ name: 'usage' });
  const provider_id = useWatch<InstructionFormValues, 'provider_id'>({ name: 'provider_id' });
  const airport_id = useWatch<InstructionFormValues, 'airport_id'>({ name: 'airport_id' });

  return (
    <Stack spacing="4" w="full">
      <SimpleSelect name="usage" label="Instruction Usage" options={instructionUsageOptions} />

      <Stack direction="row">
        <SimpleSelect name="aircraft_type" label="Aircraft" options={aircraftTypeOptions} />
        <SimpleInput label="Flight Number" name="flight_number" />
      </Stack>

      <Stack direction="row">
        <SimpleField name="provider_id" label="Airline">
          <AirlineInput name="provider_id" />
        </SimpleField>
        <SimpleField name="airport_id" label="Airport">
          <AirportInput name="airport_id" />
        </SimpleField>
      </Stack>
      <HStack>
        <SimpleInput name="airline_product" label="Airline Product" />
        <Show if={instructionUsage === InstructionUsage.BOOKING}>
          <SimpleWeekdaySelect name={`schedule`} label="Day of week" />
        </Show>
      </HStack>

      <Show if={instructionUsage === InstructionUsage.QUOTING}>
        <Divider />

        <Stack>
          <Text>Drop-Off At</Text>
          <AddressForm name="delivery_address" />
          <Stack direction="row" align="center" w="full">
            <SimpleSelect
              name="from_dock_hours"
              label="From Dock Hours"
              options={DOCK_HOURS_OPTIONS}
              variant="outline"
            />
            <SimpleSelect name="to_dock_hours" label="To Dock Hours" options={DOCK_HOURS_OPTIONS} variant="outline" />
          </Stack>
        </Stack>

        <Divider />

        <SimpleTextarea label="Booking Details" name="booking_instructions" />
        <SimpleTextarea label="Drop-Off Details" name="dropoff_instructions" />
        <ContactInput
          name="dropoff_contact_id"
          label="Drop-Off Contact"
          defaultAirlineIds={[provider_id]}
          defaultAirportIds={[airport_id]}
          defaultTags={['operations']}
        />
      </Show>
      <Show if={instructionUsage === InstructionUsage.BOOKING}>
        <Divider />
        <Text fontWeight="bold">Cutoff at determination:</Text>
        <HStack alignItems="stretch">
          <Stack border="1px solid" borderColor="blackAlpha.200" borderRadius="2" p="3" flexBasis="50%">
            <SimpleNumber name="cutoff_at_hours_before" label="# hours before " placeholder="0" />
            <Text fontSize="xs">If not specified or 0, then -&gt;</Text>
          </Stack>
          <Stack w="50%" border="1px solid" borderColor="blackAlpha.200" borderRadius="2" p="3">
            <SimpleNumber name="cutoff_at_time_days_before" label="Cutoff at days before departure" placeholder="0" />
            <SimpleNativeDatePicker size="sm" name="cutoff_at_time" type="time" />
          </Stack>
        </HStack>
      </Show>
    </Stack>
  );
};
